import { UntypedFormGroup, NgForm } from '@angular/forms';

export default class AdminHelpers {
  public static markFormInvalidAndFocus(f: NgForm): void {
    // Jump to fist invalid element and mark all controls as touched
    let elementToFocus: HTMLElement | null = null;
    for (const currControlName of Object.keys(f.controls)) {
      const currControl = f.controls[currControlName];
      currControl.markAsTouched();

      if (!elementToFocus && currControl.invalid) {
        elementToFocus = document.querySelector(`[name="${currControlName}"]`);

        if (!elementToFocus) {
          elementToFocus = document.querySelector(`#${currControlName}`);
        }
      }

      if (currControl instanceof UntypedFormGroup) {
        AdminHelpers.markFormGroupInvalidAndFocus(currControl as UntypedFormGroup);
      }
    }

    if (elementToFocus) {
      elementToFocus.scrollIntoView();
      elementToFocus.focus();
    }
  }

  public static markFormGroupInvalidAndFocus(g: UntypedFormGroup): void {
    // Jump to fist invalid element and mark all controls as touched
    let elementToFocus: HTMLElement | null = null;
    for (const currControlName of Object.keys(g.controls)) {
      const currControl = g.controls[currControlName];
      currControl.markAsTouched();

      if (!elementToFocus && currControl.invalid) {
        elementToFocus = document.querySelector(`[name="${currControlName}"]`);

        if (!elementToFocus) {
          elementToFocus = document.querySelector(`#${currControlName}`);
        }
      }
    }

    if (elementToFocus) {
      elementToFocus.scrollIntoView();
      elementToFocus.focus();
    }
  }
}
